import { useStore } from "zustand"

import { type Permission } from "@/lib/account/permission"
import { checkPermissions } from "@/lib/account/utils"
import { store } from "@/lib/store"

/**
 * Reactive permission check for use inside React components.
 *
 * Unlike the store's `hasPermissions` method (a stable function reference, safe
 * for imperative router guards), this hook selects a value *derived* from
 * `permissions`, so the component re-renders when permissions are loaded or
 * change. Selecting the store method directly would never re-render, since the
 * function reference never changes.
 */
export function useHasPermissions(
  required: ReadonlyArray<Permission>,
): boolean {
  return useStore(store, (s) => checkPermissions(s.permissions, required))
}
